import type { AccountDrilldownTab } from './account-drilldown-tabs';

/**
 * The account-page tab set of Flow's own (CDR) layout, in order. Fields is a
 * tab only below desktop width, where the fields column collapses into it.
 * The CDR account layout (`ACCOUNT_LAYOUTS.cdr.tabs`) reads this list.
 */
export const FLOW_ACCOUNT_TABS = [
  'fields',
  'timeline',
  'intel',
  'opps',
  'signals',
  'open-loops',
  'product-usage',
  'workspaces',
  'hierarchy',
] as const satisfies readonly AccountDrilldownTab[];

export type FlowAccountTab = (typeof FLOW_ACCOUNT_TABS)[number];

/** The CDR tab set at desktop width, where Fields is a column rather than a tab. */
export const FLOW_ACCOUNT_DESKTOP_TABS = FLOW_ACCOUNT_TABS.filter(tab => tab !== 'fields');
